import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatDate } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/ui-kit";
import { Toaster } from "sonner";
import { PhoneCall, MapPin, Phone, ChevronRight, AlertTriangle } from "lucide-react";

export default function Relances() {
  const navigate = useNavigate();
  const [list, setList] = useState(null);

  useEffect(() => { api.get("/relances").then((r) => setList(r.data)).catch(() => setList([])); }, []);

  const retard = (list || []).filter((r) => r.en_retard).length;

  return (
    <div className="p-8" data-testid="relances-page">
      <Toaster position="top-right" richColors />
      <PageHeader title="Relances" subtitle="De la plus proche à la plus lointaine — ne laisse rien filer" />

      {retard > 0 && (
        <div className="flex items-center gap-2 bg-red-50 border border-red-300 rounded-sm px-4 py-2.5 mb-4 text-sm text-red-800" data-testid="relances-retard-alert">
          <AlertTriangle className="w-4 h-4 shrink-0" />
          <span><span className="font-semibold">{retard}</span> relance{retard > 1 ? "s" : ""} en retard à traiter en priorité.</span>
        </div>
      )}

      {list === null ? (
        <div className="p-10 text-center text-slate-500">Chargement…</div>
      ) : list.length === 0 ? (
        <EmptyState icon={PhoneCall} title="Aucune relance programmée" description="Planifie une relance depuis une fiche prospect." testid="relances-empty" />
      ) : (
        <div className="space-y-3" data-testid="relances-list">
          {list.map((r) => (
            <div key={r.id} className={`flex items-center gap-4 bg-white border rounded-sm p-4 transition-colors ${r.en_retard ? "border-red-300 hover:border-red-400" : "border-slate-200 hover:border-[#B8873A]/50"}`} data-testid={`relance-row-${r.id}`}>
              <div className="w-20 shrink-0 text-center">
                <div className={`text-sm font-bold ${r.en_retard ? "text-red-600" : "text-[#111111]"}`}>{formatDate(r.date_relance)}</div>
                {r.en_retard && <div className="text-[10px] font-semibold text-red-600 uppercase tracking-wide mt-0.5">En retard</div>}
              </div>
              <div className="w-px h-10 bg-slate-100 shrink-0" />
              <button onClick={() => navigate(`/prospects/${r.id}`)} className="flex-1 min-w-0 text-left group" data-testid={`relance-open-${r.id}`}>
                <div className="font-semibold text-[#111111] group-hover:text-[#B8873A] truncate">
                  {r.prenom} {r.nom}
                  <ChevronRight className="w-3.5 h-3.5 inline-block ml-0.5 -mt-0.5 opacity-0 group-hover:opacity-100" />
                </div>
                <div className="text-xs text-slate-500 flex items-center gap-3 mt-0.5">
                  {r.programme && <span className="truncate">{r.programme}</span>}
                  {(r.ville || r.code_postal) && <span className="flex items-center gap-1 shrink-0"><MapPin className="w-3 h-3" />{[r.code_postal, r.ville].filter(Boolean).join(" ")}</span>}
                  {r.telephone && <span className="flex items-center gap-1 shrink-0"><Phone className="w-3 h-3" />{r.telephone}</span>}
                </div>
              </button>
              {r.statut && (
                <span className="text-[10px] font-semibold px-2 py-1 rounded-full border shrink-0 bg-amber-50 text-amber-700 border-amber-200">
                  {r.statut}
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
